var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{key:_vm.stat.id,staticClass:"statistic"},[_c('span',{staticClass:"value"},[_vm._v(_vm._s(_vm.stat.statistic))]),_c('p',{staticClass:"statement"},[_vm._v(" "+_vm._s(_vm.stat.summary)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }